import React from 'react';
import { useNavigate } from 'react-router-dom';
// const BASE_URL = 'http://localhost/Googlelogin/';
const BASE_URL = 'https://freshskills.in/adminbackend/';

const CourseCard = ({ lecture, hasAccess, loadingAccess }) => {
  const navigate = useNavigate();

  const handleWatchNow = () => {
    // console.log(`Clicked on: ${lecture.category} | Has access: ${hasAccess}`);

    if (hasAccess) {
      navigate(`/dashboard?category=${encodeURIComponent(lecture.category)}`);
    } else {
      alert('You do not have access to this lecture. Please contact admin.');
    }
  };
  
  // full image path
  const bannerImage = lecture.banner
    ? `${BASE_URL}uploads/banners/${lecture.banner}`
    : 'https://community.nasscom.in/sites/default/files/styles/960_x_600/public/media/images/DATA%20SCIENCE%20MODEL.jpg?itok=Uw9IQgUd';

  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="card h-100 shadow-sm border-0 rounded-4 overflow-hidden shadow-lg">
        <img
          src={bannerImage}
          className="card-img-top"
          alt={lecture.category}
          style={{ height: '220px', objectFit: 'cover' }}
        />
        <div className="card-body d-flex flex-column p-4 bg-light">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title fw-bold text-dark text-truncate m-0">
              {lecture.category}
            </h5>
            <img src="images/fs.png" width={30} height={30} alt="icon" className="opacity-50" />
          </div>
          {!hasAccess && <p>₹{lecture.price}</p>}
          <button
            className={`btn btn-lg mt-auto rounded-pill ${
              hasAccess ? 'btn-gradient text-white' : 'noaccess text-white'
            }`}
            onClick={handleWatchNow}
            disabled={loadingAccess}
          >
            {loadingAccess ? 'Checking...' : hasAccess ? 'Watch Now' : 'No Access'}
          </button>
        </div>
      </div>
    </div>

  );
};

export default CourseCard;
